import { createStyles } from '@material-ui/core';
import token from '@uipath/apollo-core';
export const MuiSelect = (palette) => {
    return createStyles({
        icon: { color: palette.semantic.colorForeground },
        root: {
            fontStyle: 'normal',
            fontWeight: 'normal',
            paddingTop: token.Padding.PadXl,
            paddingBottom: token.Padding.PadXl,
            paddingLeft: token.Padding.PadXxxl,
            fontSize: token.FontFamily.FontMSize,
            lineHeight: token.FontFamily.FontMLineHeight,
            color: palette.semantic.colorForeground,
        },
    });
};
